/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.13",
  "buildId": "20260801-2046-51fa1b1",
  "builtAt": "2026-08-01T15:16:33.067Z"
});
